import { Row, Col, Card, Statistic, Tag } from 'antd';
import {
  UserOutlined,
  PictureOutlined,
  DollarOutlined,
  ThunderboltOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons';
import type { DashboardOverview } from '@/types';

interface Props {
  data: DashboardOverview | null;
  loading: boolean;
}

const getTrendColor = (trend: string) => {
  if (trend.startsWith('+')) return '#52c41a';
  if (trend.startsWith('-')) return '#ff4d4f';
  return '#8c8c8c';
};

const getTrendIcon = (trend: string) => {
  if (trend.startsWith('+')) return <ArrowUpOutlined />;
  if (trend.startsWith('-')) return <ArrowDownOutlined />;
  return null;
};

export default function StatCards({ data, loading }: Props) {
  const cards = [
    { title: '用户总数', value: data?.users.total || 0, today: data?.users.today || 0, trend: data?.users.trend || '0%', icon: <UserOutlined />, color: '#1677ff' },
    { title: '今日新增', value: data?.users.today || 0, today: null, trend: data?.users.trend || '0%', icon: <UserOutlined />, color: '#1677ff' },
    { title: '图片总数', value: data?.images.total || 0, today: data?.images.today || 0, trend: data?.images.trend || '0%', icon: <PictureOutlined />, color: '#722ed1' },
    { title: '今日图片', value: data?.images.today || 0, today: null, trend: data?.images.trend || '0%', icon: <PictureOutlined />, color: '#722ed1' },
    { title: '总营收', value: data?.revenue.total || 0, today: data?.revenue.today || 0, trend: data?.revenue.trend || '0%', icon: <DollarOutlined />, color: '#52c41a', prefix: '¥', precision: 2 },
    { title: '今日营收', value: data?.revenue.today || 0, today: null, trend: data?.revenue.trend || '0%', icon: <DollarOutlined />, color: '#52c41a', prefix: '¥', precision: 2 },
    { title: 'AI调用总量', value: data?.aiUsage.total || 0, today: data?.aiUsage.today || 0, trend: data?.aiUsage.trend || '0%', icon: <ThunderboltOutlined />, color: '#faad14' },
    { title: '今日AI调用', value: data?.aiUsage.today || 0, today: null, trend: data?.aiUsage.trend || '0%', icon: <ThunderboltOutlined />, color: '#faad14' },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card, idx) => (
        <Col xs={12} sm={6} key={idx}>
          <Card size="small" style={{ borderTop: `3px solid ${card.color}` }}>
            <Statistic
              title={card.title}
              value={card.value}
              prefix={card.prefix || card.icon}
              precision={card.precision}
              loading={loading}
              valueStyle={{ fontSize: 24 }}
            />
            <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 4 }}>
              <Tag
                icon={getTrendIcon(card.trend)}
                color={getTrendColor(card.trend)}
                style={{ margin: 0, fontSize: 12 }}
              >
                {card.trend}
              </Tag>
              {card.today !== null && (
                <span style={{ fontSize: 12, color: '#8c8c8c' }}>今日 {card.today}</span>
              )}
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
